import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translation_en from './en.json';
import translation_zh from './zh.json';

const resources = {
    en: {
        translation: translation_en,
    },
    zh: {
        translation: translation_zh,
    },
};

function getInitLang() {
    const lang = localStorage.getItem('wohui:lang') || navigator.language.split('-')[0];
    return lang === 'zh' ? 'zh' : 'en';
}

i18n.use(initReactI18next).init({
    resources,
    // lng: process.env.REACT_APP_ENVIRONMENT || 'en',
    lng: getInitLang(),
    interpolation: {
        escapeValue: false,
    },
});

export default i18n; 